import _ from "lodash";

const ORDER_STATUS_TRANSLATION_KEY = {
  0: "cancelled",
  1: "searching",
  3: "out_for_pickup",
  3.5: "reached_pickup",
  4: "picked_up",
  5: "in_transit",
  10: "out_for_delivery",
  10.5: "reached_delivery",
  11: "delivered",
  12: "undelivered",
  19: "rto_initiated",
  20: "rto_ofd",
  21: "rto_undelivered",
  22: "rto_delivered",
  23: "open",
  24: "closed",
  42: "disposed",
};

const ORDER_STATUS = {
  AWB_Registered: {
    id: 1,
    text: "Searching",
  },
  Out_For_Pickup: {
    id: 3,
    text: "Out For Pickup",
  },
  Picked_Up: {
    id: 4,
    text: "Picked Up",
  },
  In_Transit: {
    id: 5,
    text: "In Transit",
  },
  Out_For_Delivery: {
    id: 10,
    text: "Out For Delivery",
  },
  Undelivered: {
    id: 12,
    text: "Undelivered",
  },
  Delivered: {
    id: 11,
    text: "Delivered",
  },
  RTO_OFD: {
    id: 20,
    text: "RTO OFD",
  },
  RTO_Delivered: {
    id: 22,
    text: "RTO Delivered",
  },
  RTO_Undelivered: {
    id: 21,
    text: "RTO Undelivered",
  },
  LOST: {
    id: 40,
    text: "LOST",
  },
  DAMAGED: {
    id: 41,
    text: "DAMAGED",
  },
  Cancelled: {
    id: 0,
    text: "Cancelled",
  },
  Disposed_off: {
    id: 42,
    text: "Disposed off",
  },
  Pick_Up_Exception: {
    id: 13,
    text: "Pick Up Exception",
  },
  RTO_Initiated: {
    id: 19,
    text: "RTO Initiated",
  },
  //Third Party CDR statuses
  CANCELLED: {
    id: 0,
    text: "Cancelled",
  },
  CREATED: {
    id: 1,
    text: "Searching",
  },
  OUT_FOR_PICKUP: {
    id: 3,
    text: "Out For Pickup",
  },
  REACHED_PICKUP: {
    id: 3.5,
    text: "Reached Pickup",
  },
  PICKED_UP: {
    id: 4,
    text: "Picked Up",
  },
  IN_TRANSIT: {
    id: 5,
    text: "In Transit",
  },
  OUT_FOR_DELIVERY: {
    id: 10,
    text: "Out For Delivery",
  },
  REACHED_DELIVERY: {
    id: 10.5,
    text: "Reached Delivery",
  },
  DELIVERED: {
    id: 11,
    text: "Delivered",
  },
  UNDELIVERED: {
    id: 12,
    text: "Undelivered",
  },
  RTO_OUT_FOR_DELIVERY: {
    id: 20,
    text: "RTO Out for delivery",
  },
  RTO_UNDELIVERED: {
    id: 21,
    text: "RTO Undelivered",
  },
  RTO_DELIVERED: {
    id: 22,
    text: "RTO Delivered",
  },
  OPEN: {
    id: 23,
    text: "Open",
  },
  CLOSED: {
    id: 24,
    text: "Closed",
  },
  DISPOSED: {
    id: 42,
    text: "Disposed",
  },
};

const constant = {
  BASE_URL: {
    DEFAULT: "API_URL",
    STORE: "API_STORE_URL",
    TRACE: "API_TRACE_URL",
  },
  AUTH_TOKEN: "auth_token",
  TYPE_OF_OWNER: "type_of_owner",
  OWNER_ID: "owner_id",
  PARENT_ID: "parent_id",
  USER_DETIALS: "user_details",
  SELECTED_BUSINESS: "selected_business",
  SELECTED_BUSINESS_ID: "selected_business_id",
  SELECTED_LANGUAGE: "selected_language",
  BUSINESS_ACCOUNT: "buiness_account",
  SELECTED_COUNTRY: "selected_country",
  GOOGLE_MAP_KEY:
    process.env.REACT_APP_ENVIRONMENT === "dev"
      ? "AIzaSyDHgbNwCshqEti3E1bDvPsIYB-27bWxYvA"
      : "AIzaSyASjGKlFafGpHWa37_3MQcpsxaSFBFRSTU",
  ORDER_STATUS,
  ORDER_STATUS_TEXT: _.reduce(
    ORDER_STATUS,
    (map, status) => {
      map[status.id] = status.text;
      return map;
    },
    {}
  ),
  CURRENT_LOCATION: "current_location",
  CURRENT_LAT_LNG: "current_lat_lng",
  ORDER_STATUS_TRANSLATION_KEY
};

export default constant;
